import { render, staticRenderFns } from "./saleBack.vue?vue&type=template&id=6d9403c1&scoped=true&"
import script from "./saleBack.vue?vue&type=script&lang=js&"
export * from "./saleBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9403c1",
  null
  
)

export default component.exports